import { Injectable, inject } from '@angular/core';
import {BaseService} from './base-service';
import {Observable} from 'rxjs';
import {API_URL} from '../shared/api';
import { map, tap } from 'rxjs/operators';
import { TourService } from 'ngx-ui-tour-md-menu'

export interface SearchResultEntry {
  id: number | string;  // Could be a UUID or DB auto-assigned numeric unique ID
  name: string;
  groupId: number;
}

export interface BitlockerRecoverKeyResult {
  endpointName: string;
  groupId: number;
  diskSerial: string;
  licenseUuid: string;
  volConfigId: number;
  keyId: string;
}

export interface SearchResults {
  endpoints: SearchResultEntry[];
  endpointGroups: SearchResultEntry[];
  userGroups: SearchResultEntry[];
  policies: SearchResultEntry[];
  users: SearchResultEntry[];
  organizations: SearchResultEntry[];
  bitlockerRecoveryKeys: {[key: string]: BitlockerRecoverKeyResult[]}
}

export interface SearchResultResponse {
  data: SearchResults;
}

export interface RecentResultEntry {
  id: number | string;
  name: string;
  groupId: number;
  dttm: Date;
}

export interface RecentResults {
  activations: RecentResultEntry[];
  users: RecentResultEntry[];
}

export interface RecentResultResponse {
  data: RecentResults;
}

@Injectable({
  providedIn: 'root'
})
export class SearchService extends BaseService {
  private readonly tourService = inject(TourService);
  first = true;
  getSearchResults(term: string, limit: number): Observable<SearchResults> {
    const query = [
      ['q', term],
      ['limit', limit.toString()],
    ];
    const url = this.getUrl(API_URL.GLOBAL_SEARCH, query);
    return this.http.get<SearchResultResponse>(url).pipe(
      map(response => response.data),
      tap(() => {
        if (this.first) {
          this.tourService.next();
          this.first = false;
        }
      })
    );
  }

  getRecentResults(): Observable<RecentResults> {
    const url = this.getUrl(API_URL.RECENT_SEARCH);
    return this.http.get<RecentResultResponse>(url).pipe(
      map(response => response.data)
    );
  }
}
